import styled from 'styled-components';
import { pxToRem } from 'utils/convert';
import { Body2, spacing, textColors, fontSizes, borderColors } from 'ui/theme';
import { layoutLRPadding } from 'ui/theme/spacing';
import { Skeleton } from 'ui/skeleton';
import { InsightPanel } from '../insightPanel/InsightPanel';

export const BehaviorInsightsContentWrapper = styled.div`
  margin: 0 ${layoutLRPadding};
  display: flex;
`;

export const BehaviorInsightsActionsWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const InsightsSectionWrapper = styled.div`
  width: 100%;
  display: grid;
  grid-template-columns: repeat(auto-fit, ${pxToRem(258)});
  grid-template-rows: repeat(auto-fit, ${pxToRem(104)});
  padding: ${spacing.plusHalf};
  grid-column-gap: ${spacing.double};
  grid-row-gap: ${spacing.double};
  grid-auto-flow: row;
`;

export const NumberWrapper = styled.div`
  align-items: center;
  column-gap: ${spacing.half};
  color: ${textColors.textPrimary};
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  font-size: ${fontSizes.s20};
  font-weight: bold;
  /** $isDefined pertains to values that are not undefined or 0 */
  &[data-defined='false'] {
    ${Body2};
    font-weight: 400;
    font-size: ${fontSizes.s14};
    color: ${textColors.textSecondary};
  }
`;
export const NumberInsightPanel = styled(InsightPanel)`
  width: ${pxToRem(258)};
  height: ${pxToRem(104)};
`;

export const PercentageInsightPanel = styled(InsightPanel)`
  width: ${pxToRem(452)};
`;

export const TimeframePickerWrapper = styled.div`
  position: relative;
`;

export const ExpandedDateRangePickerWrapper = styled.div`
  position: absolute;
  top: 100%;
  right: 0;
  background-color: #fff;
  border-radius: ${spacing.half};
  margin-top: ${spacing.half};
  z-index: 10000;
`;

export const RatePanelsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.double};
  padding: ${spacing.plusHalf};
  border-right: ${spacing.single} solid ${borderColors.borderPrimarySubtle};
`;

export const PercentageWrapper = styled.div`
  font-size: ${spacing.x3};
  line-height: ${pxToRem(56)};
  font-weight: bold;
  color: ${textColors.textPrimary};
  padding-bottom: ${spacing.base};
`;

export const PercentageSkeleton = styled(Skeleton)`
  margin-bottom: ${spacing.threeQuarter};
  height: ${spacing.x4};
  padding: ${spacing.threeQuarter} 0;
`;
